/**
 * Mobile/tablet chart layout helpers (< 1024px).
 * Desktop chart options are unchanged.
 */

export const MOBILE_CHART_BREAKPOINT = 1023;

export const isMobileChartViewport = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(`(max-width: ${MOBILE_CHART_BREAKPOINT}px)`).matches;
};

export const getMobileChartLayoutPadding = () => ({
  left: 6,
  right: 6,
  top: 4,
  bottom: 8,
});

/** Dual-axis charts need extra gutter on narrow screens */
export const getMobileDualAxisLayoutPadding = () => ({
  left: 4,
  right: 4,
  top: 4,
  bottom: 10,
});

export const getMobileChartOverrides = () => ({
  layout: {
    padding: getMobileChartLayoutPadding(),
  },
  plugins: {
    legend: {
      labels: {
        padding: 12,
        boxWidth: 8,
        font: {
          size: 11,
        },
      },
    },
  },
  scales: {
    x: {
      ticks: {
        font: { size: 10 },
        maxRotation: 50,
        minRotation: 40,
        autoSkip: true,
        maxTicksLimit: 6,
        padding: 4,
      },
      title: {
        font: { size: 11 },
      },
    },
    y: {
      ticks: {
        font: { size: 10 },
        padding: 4,
        maxTicksLimit: 6,
      },
      title: {
        font: { size: 11 },
      },
    },
  },
});

/** X-axis ticks when components previously forced every label visible */
export const getResponsiveXAxisTicks = (overrides: Record<string, unknown> = {}) => {
  const base = {
    autoSkip: false,
    maxRotation: 45,
    minRotation: 45,
    padding: 5,
    ...overrides,
  };

  if (!isMobileChartViewport()) {
    return base;
  }

  return {
    ...base,
    autoSkip: true,
    maxTicksLimit: 6,
    maxRotation: 50,
    minRotation: 40,
    font: { size: 10 },
    padding: 4,
  };
};

export const getMobileDualAxisScaleOptions = () => {
  if (!isMobileChartViewport()) {
    return {};
  }

  return {
    layout: {
      padding: getMobileDualAxisLayoutPadding(),
    },
    scales: {
      y: {
        afterFit: (scaleInstance: { width: number }) => {
          scaleInstance.width = Math.max(scaleInstance.width, 68);
        },
        ticks: {
          font: { size: 9 },
          maxTicksLimit: 5,
          padding: 2,
        },
      },
      y1: {
        afterFit: (scaleInstance: { width: number }) => {
          scaleInstance.width = Math.max(scaleInstance.width, 52);
        },
        ticks: {
          font: { size: 9 },
          maxTicksLimit: 5,
          padding: 2,
        },
      },
    },
  };
};
